import {Alert, Typography,} from "@mui/material";
import {ViewPopup} from "components/Admin/Pages/ViewPopup/ViewPopup";
import {userService} from "services/userService";
import {BooleanField, TextField, useTranslate} from "react-admin";
import React, {FC} from "react";
import {Label} from "../../../components/Label/Label";

export const UserView: FC = () => {
  const t = useTranslate();

  return (
    <ViewPopup
      query={userService.getById}
      label={(record) => record?.username}
    >
      {(record) => (
        <>
          {record?.active !== undefined && (
            <Alert
              severity={record?.active ? "success" : "error"}
              sx={{mb: 2}}
            >
              {t(`resources.users.options.active.${record?.active ? "ACTIVE" : "BLOCKED"}`)}
            </Alert>
          )}
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="username"/>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {record?.username}
          </Typography>
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="email"/>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {record.email}
          </Typography>
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="permissions"/>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {record.permissions
              ?.map((permission) => t(`resources.users.options.permissions.${permission}`))
              .join(", ")}
          </Typography>
        </>
      )}
    </ViewPopup>
  );
};
